import React, { useState, useEffect, useRef } from 'react';
import ReactDOM from 'react-dom';
import styles from './DropdownButton.module.scss';
import SvgWithBranding from 'component/hoc/branding/withBrandingColor.hoc';
import Button from '../button/Button';

const DropdownButton = ({
  items,
  onClose,
  isMulty = false,
  disabled,
  type,
  position = 'bottom',
  height,
  isButton,
  isTransparent,
}) => {
  const [isPortalOpen, setPortalOpen] = useState(false);
  const [animationClass, setAnimationClass] = useState('');
  const [dropdownWidth, setDropdownWidth] = useState(0);
  const btnRef = useRef();
  const portalRef = useRef();
  const portalRoot = document.getElementById('portal-root') || document.body;
  const dropdownHeight = height ?? 125;
  const getPortalPosition = () => {
    const rect = btnRef?.current?.getBoundingClientRect();
    const isTop = position === 'top';
    const isLeft = position === 'left';
    return {
      top: isTop
        ? rect?.top - dropdownHeight + window.scrollY
        : rect?.bottom + window.scrollY,
      left: isLeft
        ? rect?.left - dropdownWidth + window.scrollX
        : rect?.left + window.scrollX,
      position: 'absolute',
    };
  };
  const openPortal = () => {
    if (disabled) return;
    setPortalOpen(true);
    setAnimationClass('entering');
    setTimeout(() => {
      if (portalRef.current) {
        setDropdownWidth(portalRef.current.offsetWidth);
      }
    }, 0);
  };

  const closePortal = () => {
    setAnimationClass('exiting');
    setTimeout(() => {
      setPortalOpen(false);
      setAnimationClass('');
      if (onClose) onClose();
    }, 300);
  };

  const handleClickOutside = (event) => {
    if (
      portalRef.current &&
      !portalRef.current.contains(event.target) &&
      !btnRef.current.contains(event.target)
    ) {
      closePortal();
    }
  };

  const handleScroll = () => {
    closePortal();
  };

  useEffect(() => {
    if (isPortalOpen) {
      document.addEventListener('mousedown', handleClickOutside);
      window.addEventListener('scroll', handleScroll, { passive: true });
    } else {
      document.removeEventListener('mousedown', handleClickOutside);
      window.removeEventListener('scroll', handleScroll);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
      window.removeEventListener('scroll', handleScroll);
    };
  }, [isPortalOpen]);

  const portalContent = (
    <div
      ref={portalRef}
      className={`${styles['portal-content']} ${styles[animationClass]}`}
      style={getPortalPosition()}
    >
      {items?.map((item, index) => (
        <div
          className={styles.ss}
          key={index}
          onClick={!isMulty ? closePortal : undefined}
        >
          <div className={styles.btn} onClick={item.function}>
            {item.type ? <SvgWithBranding type={item.type} /> : null}
            <p>{item.label}</p>
          </div>
        </div>
      ))}
    </div>
  );

  return (
    <div className={styles['portal-container']} ref={btnRef}>
      <span className={styles['expend-btn']} onClick={openPortal}>
        {isButton ? (
          <Button
            className={styles['button']}
            type={type}
            buttonType="button"
            transparent={isTransparent}
          />
        ) : (
          <SvgWithBranding
            type={type}
            className={`${disabled ? styles.disabled : ''}`}
          />
        )}
      </span>

      {isPortalOpen && ReactDOM.createPortal(portalContent, portalRoot)}
    </div>
  );
};

export default DropdownButton;
